import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function Falafels() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Falafels</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>
        5000g dried chickpeas <br></br>1 brown onion<br></br>3 garlic cloves
        <br></br>
        Fresh Coriander<br></br>
        Fresh parsley<br></br>
        Plain flour<br></br>
        Ground Cumin<br></br>
        Cayenne pepper<br></br>
        Olive oil<br></br>
        <b>Salad</b>
        <br></br>
        4-6 tomatoes<br></br>1 cucumber<br></br>
        Fresh mint<br></br>
        Fresh parsley<br></br>1 lemon<br></br>
        Olive oil<br></br>
      </Typography>

      <Typography>
        Pour the dried chickpeas into a bowl, cover with warm water and soak
        overnight<br></br>
        <br></br>
        Preheat the oven to 180C.<br></br>
        Start with the falafel mix. Add the soaked, dried chickpeas, a chopped
        brown onion, the garlic cloves, a large handful of coriander, a large
        handful of parsley, 2 tbsp of flour, 2 tsp of cumin and 1 tsp of cayenne
        pepper into a blender.<br></br>
        Season with salt and pepper.<br></br>
        <br></br>
        Pulse the mixture in a blender. <br></br> You want the texture to be
        rough so don't overdo it.<br></br>
        Pulsing 3-4 times for 5 seconds each time should do the trick.<br></br>
        Check teh falafel misture can stick in a ball. If it is too loose, just
        a dd a bit more flour.<br></br>
        <br></br>
        Make little discs, around 4cm wide, and 3cm deep.<br></br>
        Line them up on a sheet of baking paper, and put them in the fridge for
        10 miuntes to firm up. <br></br>
        The mixture should make about 20 discs.<br></br>
        <br></br>
        Salad time. Chop the tomatoes, peel the cucumber and chop it into
        chunks, and add to a bowl.<br></br>
        Add a handful of chopped mint, a handful of chopped parsley, the juice
        of a lemon, salt, pepper, and a glug of olive oil.<br></br>
        Mix.<br></br>
        <br></br>
        Falafel time. Line a baking sheet with baking paper, and place your
        falafel on it.<br></br>
        Drizzle lightly with olive oil on one side,and then turn over the
        falafel and drizzle olive oil on the other side.<br></br>
        Pat in the oil with your fingers, and then place in the hot oven for 30
        minutes, flipping the falafel after 20 minutes.<br></br>
        <br></br>
        Serve with warm pitta bread and hummus.<br></br>
      </Typography>
    </Card>
  );
}
